import { data } from "jquery";
import { MAVERICK_API_PREFIX } from "../../../common/configs/configs";
import ApiUtils from "../utils/ApiUtils";
import AppUtils from "../utils/AppUtils";
export class GenericActions {
    static getTypeAheadData = function (input: string, typeAheadConfig: any, shouldSendOverridenData?: boolean) {
        let additionalParams = { ...typeAheadConfig.additionalParams, [typeAheadConfig.inputParam]: input };

        // this hardcoding is for adhoc testing of search improvement by directly sending params to elastic search
        // this should be removed later
        const overridenData: string = GenericActions.getoverRiddenData(typeAheadConfig, additionalParams, shouldSendOverridenData);
        if (overridenData) {
            return ApiUtils.apiPostRequest(typeAheadConfig.url, overridenData);
        }

        let url = `${typeAheadConfig.url}?${additionalParams ? ApiUtils.requestToQueryParams(additionalParams) : ""}`;
        if (url.includes(MAVERICK_API_PREFIX)) {
            url = AppUtils.addConsIdAndDocIdtoUrlParams(url);
        }
        return ApiUtils.apiGetRequest(url);
    }

    static getoverRiddenData(typeAheadConfig: any, additionalParams: any, shouldSendOverridenData?: boolean): string {
        let data: string;
        if (shouldSendOverridenData && typeAheadConfig.url.indexOf("medicine_catalogue") !== -1) {
            data = JSON.stringify({
                "size": 10,
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "should": [
                                    {
                                        "match_phrase_prefix": {
                                            "productName": {
                                                "query": additionalParams && additionalParams.q,
                                                "slop": 0,
                                                "max_expansions": 50,
                                                "boost": 1
                                            }
                                        }
                                    },
                                    {
                                        "match_phrase_prefix": {
                                            "molecule": {
                                                "query": additionalParams && additionalParams.q,
                                                "slop": 0,
                                                "max_expansions": 50,
                                                "boost": 0.2
                                            }
                                        }
                                    }
                                ],
                                "adjust_pure_negative": true,
                                "minimum_should_match": "1",
                                "boost": 1
                            }
                        },
                        "functions": [
                            {
                                "script_score": {
                                    "script": {
                                        "inline": "1+100000*doc['popularityScore'].value"
                                    }
                                }
                            }
                        ],
                        "score_mode": "multiply",
                        "boost_mode": "multiply"
                    }
                }
            });
        } else if (typeAheadConfig.url.indexOf("disease_catalogue") !== -1) {
            data = JSON.stringify({
                "query": {
                    "function_score": {
                        "query": {
                            "bool": {
                                "should": [{
                                    "match_phrase_prefix": {
                                        "name": {
                                            "query": additionalParams && additionalParams.q,
                                            "boost": 2
                                        }
                                    }
                                }, {
                                    "match_phrase_prefix": {
                                        "alternateNames": {
                                            "query": additionalParams && additionalParams.q,
                                            "boost": 1
                                        }
                                    }
                                }]
                            }
                        },
                        "functions": [{
                            "script_score": {
                                "script": {
                                    "inline": "1+10000*doc['priority'].value"
                                }
                            }
                        }],
                        "score_mode": "multiply",
                        "boost_mode": "multiply"
                    }
                }
            });
        }
        return data;
    }
}